/**
 * @author: liaosir
 * @description: FpxBarChart
 */

import React, { useEffect, useState } from 'react';
import { Box } from '@fpxfd/next';
import styles from './index.module.scss';
import { Props } from './index.interface';

const FpxBarChart = (props: Props) => {
  const { data, title, description, xField, yField, color, tooltip, xAxis, yAxis, dark } = props;

  const [total, setTotal] = useState(0);
  /**
   * 用于设置toolTip的位置
   */
  const [left, setLeft] = useState(0);
  const [top, setTop] = useState(0);

  /**
   * 计算出共有多少条数据，用以计算柱形图百分比
   */
  useEffect(() => {
    let res: any = 0;
    data.forEach((e) => {
      if (e?.[yField]) res += e?.[yField];
    });
    setTotal(res);
  }, [data, yField]);

  return (
    <div className={`${styles.FpxBarChart} ${dark && styles.DarkStyle}`}>
      {title && <div className={styles.title}>{title}</div>}
      {description && <div className={styles.description}>{description}</div>}

      {data && (
        <ul>
          {data?.map((e: any, i: number) => {
            if (!e?.[xField]) return;
            return (
              <li key={i}>
                <span
                  className={styles.xField}
                  onClick={() => (props?.events?.onAxisXClick ? props?.events?.onAxisXClick(e) : '')}
                >
                  {xAxis?.label?.formatte ? xAxis?.label?.formatte(e?.[xField]) : e?.[xField]}
                </span>
                <Box direction="row" align="center" justify="space-between" style={{ height: '50%' }}>
                  <div
                    className={styles.barBox}
                    onClick={(ev) => {
                      ev.stopPropagation();
                      props?.events?.onPlotClick && props?.events?.onPlotClick(e);
                    }}
                    onMouseMove={(move) => {
                      const l =
                        move.nativeEvent.offsetX + 50 > 300 ? move.nativeEvent.offsetX - 150 : move.nativeEvent.offsetX;
                      const t = move.nativeEvent.offsetY - 90;
                      setLeft(l);
                      setTop(t);
                    }}
                  >
                    <div
                      className={styles.barBoxContent}
                      style={{
                        backgroundColor: color(e),
                        width: `${(e?.[yField] / total) * 100}%`,
                        minWidth: e?.[yField] === 0 ? '0px' : '1px',
                      }}
                      onClick={(ev) => {
                        ev.stopPropagation();
                        props?.events?.onBarClick && props?.events?.onBarClick(e);
                      }}
                    />
                    {tooltip?.fields && (
                      <div
                        className={styles.tooltip}
                        style={{
                          left: `${left}px`,
                          top: `${top}px`,
                        }}
                      >
                        <div className={styles.tipTitle}>{e?.module}</div>
                        <ul>
                          {tooltip?.fields?.map((tip: string, ti: number) => {
                            return (
                              <li key={ti}>
                                <i style={{ backgroundColor: color(e) }} />
                                <span className={styles.textLeft}>{tip}:</span>
                                <span className={styles.textRight}>{e?.[tip]}</span>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                  </div>
                  <span
                    className={styles.yFeild}
                    onClick={() => (props?.events?.onAxisYClick ? props?.events?.onAxisYClick(e) : '')}
                  >
                    {yAxis?.label?.formatte ? yAxis?.label?.formatte(e?.[yField]) : e?.[yField]}
                  </span>
                </Box>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default FpxBarChart;
